import React from 'react';
import { useNavigate } from 'react-router-dom';

function ErrorPage() {
    const navigate = useNavigate();
    const backToHome = () => {
        navigate('/');
    };

    return (
        <div className="container-fluid text-center">
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <img src="/Images/404-Screen Illustration.svg" className="error-img" alt="404-Error-img" />
                    <p className="font-35 semibold-text text-center mb-2">Whoops, Error-404!</p>
                    <p className="font-20 medium-text text-center mb-0">The page you're looking for isn't found? 😔</p>
                    <p className="font-20 medium-text text-center mb-5">We suggest you to go back to home</p>
                    <button
                        onClick={() => {
                            backToHome();
                        }}
                        className="btn hive-btn-error"
                    >
                        Back To Lobby
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
